import {match} from 'ts-pattern';

import type {AppSyncDataPayload, AppSyncMessage} from '../types';
import {captureWebsocketError} from './captureWebsocketError';

interface MessageHandlers {
  onConnectionAck: (keepAliveTimeoutMs: number) => void;
  onSubscriptionAck: () => void;
  onData: (payload: AppSyncDataPayload) => void;
  onError: (error: unknown) => void;
  onComplete: () => void;
  onKeepAlive: () => void;
}

export const handleWebSocketMessage = (
  message: AppSyncMessage,
  handlers: MessageHandlers
): void => {
  match(message)
    .with({type: 'connection_ack'}, ({payload}) =>
      handlers.onConnectionAck(payload.connectionTimeoutMs)
    )
    .with({type: 'start_ack'}, () => handlers.onSubscriptionAck())
    .with({type: 'data'}, ({payload}) => handlers.onData(payload))
    .with({type: 'error'}, {type: 'connection_error'}, ({payload}) => handlers.onError(payload))
    .with({type: 'complete'}, () => handlers.onComplete())
    .with({type: 'ka'}, () => handlers.onKeepAlive())
    .otherwise((unknownMessage) => {
      console.error('Unknown AppSync message type', unknownMessage);
      captureWebsocketError(
        new Error(`Unknown AppSync message type: ${String(unknownMessage.type)}`)
      );
    });
};
